<template>
  <v-card outlined class="mb-4">
    <v-tabs v-model="tab" show-arrows>
      <v-tab v-for="(language, index) in languages" :key="index">{{ language.code }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(language, index) in languages"
        :key="index"
        :transition="false"
        :reverse-transition="false"
        class="px-4 py-4"
      >
        <slot :language="language" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  props: {
    languages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tab: null,
    }
  },
}
</script>
